import LXSelector from './lxSelector';

interface LXPageSizeSelectorProps {
  value: number;
  onSelect: (pageSize: number) => void;
}

const LXPageSizeSelector = (props: LXPageSizeSelectorProps) => {
  return (
    <LXSelector<number>
      dropdownHeaderWidth={96}
      dropdownItemWidth={120}
      value={props.value}
      values={[20, 40, 60, 80, 100]}
      labels={['20', '40', '60', '80', '100']}
      onSelect={props.onSelect}
      dropdownDirection={'top'}
    ></LXSelector>
  );
};

export default LXPageSizeSelector;
